import Library from "../components/workout/Library";

export default function LibraryPage({ user, workoutName, onRepeatWorkout }) {
  return (
    <Library user={user} workoutName={workoutName} onRepeatWorkout={onRepeatWorkout} />
  );
}
